import {
  DialogDescription,
  DialogDismiss,
  DialogHeading,
  Form,
  useDialogContext,
} from "@ariakit/react";
import {
  Failure,
  ModalDialog,
  SubmitErrorAlert,
  Success,
  useForm,
} from "@indietabletop/appkit";
import { type ButtonVariants } from "../../common/common.css.ts";
import { FormDialogSubmitButton } from "../forms/DialogSubmitButton.tsx";
import * as css from "./style.css.ts";

type ConfirmDialogProps<T> = {
  heading: string;
  description: string;
  submitLabel: string;
  theme?: ButtonVariants["theme"];
  onSubmit: () => Promise<Success<T> | Failure<string>>;
  onSuccess?: (value: T) => void;
};

export function ConfirmDialog<T>(props: ConfirmDialogProps<T>) {
  const dialog = useDialogContext();
  const { form, submitName } = useForm({
    defaultValues: {},
    onSubmit: props.onSubmit,
    onSuccess(value) {
      props.onSuccess?.(value);
      dialog?.hide();
    },
  });

  return (
    <ModalDialog size="small" className={css.dialog}>
      <Form store={form} autoComplete="off" className={css.content}>
        <DialogHeading className={css.heading}>{props.heading}</DialogHeading>

        <DialogDescription className={css.description}>
          {props.description}
        </DialogDescription>

        <div className={css.footer}>
          <SubmitErrorAlert name={submitName} className={css.submitError} />

          <div className={css.buttons}>
            <DialogDismiss className={css.cancelButton}>Cancel</DialogDismiss>

            <FormDialogSubmitButton theme={props.theme}>
              {props.submitLabel}
            </FormDialogSubmitButton>
          </div>
        </div>
      </Form>
    </ModalDialog>
  );
}
